import * as S from './Footer.styles'

export default function Footer() {
  return (
    <S.Footer>
      Made by&nbsp;<a href="https://davidsint.com">David Sint</a>
    </S.Footer>
  );
}